import { SVG_ShiftRect } from "./SVG_ShiftRect";
import { SVG_CreateBoxPath } from "./SVG_CreateBoxPath";
import { SVG_SetDash } from "./SVG_SetDash";
import { SVG_GetUniqueID } from "./SVG_GetUniqueID";
import { SVG_AddGradient } from "./SVG_AddGradient";
import { enumElementBorderStyle, enumDashStyle, enumFillMode } from "../constants";

export function SVG_RenderChartBox(
  bounds,
  outerBounds,
  boxShape,
  fillMode,
  fillColor,
  borderStyle,
  borderThickness,
  borderColor,
  dashStyle,
  shadow,
  svgElement,
  backColor
) {
  var double = borderStyle == enumElementBorderStyle.doubleBorder;
  var dashed = dashStyle != enumDashStyle.nodash;

  SVG_ShiftRect(bounds, svgElement);
  SVG_ShiftRect(outerBounds, svgElement);

  var p = SVG_CreateBoxPath(bounds, boxShape);
  var shadowP = p;

  if (borderStyle == enumElementBorderStyle.noBorder) borderColor = "none";

  p.setAttribute("stroke", borderColor);
  p.setAttribute("stroke-width", borderThickness);

  if (dashed && !double) {
    SVG_SetDash(borderThickness, p);
  }

  if (double && fillMode == enumFillMode.solidFill) {
    var p1 = SVG_CreateBoxPath(outerBounds, boxShape);
    p1.setAttribute("stroke", borderColor);
    p1.setAttribute("stroke-width", 1);
    p1.setAttribute("fill", fillColor);

    if (dashed) SVG_SetDash(1, p1);

    svgElement.appendChild(p1);
    shadowP = p1;
  } else if (double && !fillMode == enumFillMode.solidFill) {
    var p1 = SVG_CreateBoxPath(outerBounds, boxShape);
    p1.setAttribute("stroke", borderColor);
    p1.setAttribute("stroke-width", 1);
    p1.setAttribute("fill", "none");

    if (dashed) SVG_SetDash(1, p1);

    svgElement.appendChild(p1);
    shadowP = p1;
  }

  if (fillMode == enumFillMode.solidFill) {
    p.setAttribute("fill", fillColor);
  } else if (fillMode == enumFillMode.linearGradientDown) {
    var idStr = SVG_GetUniqueID("gradient");
    SVG_AddGradient(idStr, fillColor, backColor, svgElement);

    var gradientIDString = "url(#" + idStr + ")";
    //TODO: form up the ID string as the url#gradient construct
    p.setAttribute("fill", gradientIDString);
  } else if (fillMode === enumFillMode.opacityfill) {
    p.setAttribute("fill", fillColor);
    p.setAttribute("fill-opacity", 0.2);
  } else {
    fillColor = "none";
    p.setAttribute("fill", fillColor);
  }
  svgElement.appendChild(p);

  if (shadow) shadowP.setAttribute("filter", "url(#f1)");
}
